<!-- Our Team Block -->
<section id="agent">
  <div class="container text-center">
    <div *ngIf="agent" class="row">
      <div class="col-12 col-md-3 col-lg-2">
        <div class="card block">
          <img
            class="card-img-top"
            src="{{ cdnPath + agent.image }}"
            alt="{{ agent.fullName }}"
          />
        </div>
        <!-- <div class="agent-info">
          <h4 class="card-title">{{ agent.fullName }}</h4>
          <h6>
            <span *ngIf="agent.phone"
              >Direct Line:
              <a [attr.href]="'callto:' + agent.phone | safeUrl">{{
                agent.phone
              }}</a>
            </span>
            <span *ngIf="agent.email">
              Email:
              <a href="mailto:{{ agent.email }}">{{ agent.email }}</a>
            </span>
          </h6>
        </div> -->
      </div>
      <div class="col-12 col-md-9 col-lg-10 agent-info">
        <h4 class="card-title">{{ agent.fullName }}</h4>
        <h6>
          <span *ngIf="agent.phone"
            >Direct Line:
            <a [attr.href]="'callto:' + agent.phone | safeUrl">{{
              agent.phone
            }}</a>
          </span>
          <span *ngIf="agent.email">
            Email:
            <a href="mailto:{{ agent.email }}">{{ agent.email }}</a>
          </span>
        </h6>
      </div>
      <!-- <div class="col-12 info-text">
        <span *ngIf="!showReferredBlock">Please complete the form below and I will contact you with a  quote shortly.</span>
        <span *ngIf="showReferredBlock">Welcome! You were referred by <b style="color: red;">{{referredName}}</b>. Please complete the form below to save $100 on your purchase.</span>
      </div> -->
    </div>
  </div>
</section>
<app-agent-searchbox *ngIf="!chiefPage" [agent]="agent" [referralCode]="referralCode"></app-agent-searchbox>
<app-agent-pay  [agent]="agent"></app-agent-pay>

<app-service></app-service>
<app-yelp-reviews *ngIf="chiefPage" [chiefPage]="true"></app-yelp-reviews>

<section *ngIf="!chiefPage" id="reviews-page">
  <div class="container agent-reviews">
    <h4>Reviews and testimonials from my customers.</h4>
    <!-- Button trigger modal -->
    <button
      *ngIf="!chiefPage"
      type="button"
      class="btn"
      (click)="openWriteReviewDialog()"
    >
      Write a review
    </button>
    <ng-container *ngFor="let review of reviews">
      <app-review-item [review]="review"></app-review-item>
    </ng-container>
  </div>

  <ngb-pagination
    *ngIf="totalItems != 0"
    class="pagination justify-content-center"
    [collectionSize]="totalItems"
    [(page)]="currentPage"
    [pageSize]="itemsPerPage"
    [maxSize]="maxSize"
    [rotate]="true"
    (pageChange)="loadPage($event)"
  ></ngb-pagination>
</section>
